import React, { useEffect, useState } from 'react';
import './AssetDetail.scss'; // Import your CSS file for styling
import PdfPreview from 'componentsV2/PDFPreview/PdfPreview';
import RightSection from './RightSection';
import { findElementByPrompt } from 'utils/utils';

interface AssetDetailContentProps {
  assetDetails: any;
}

const AssetDetailContent: React.FC<AssetDetailContentProps> = ({ assetDetails }) => {

  const [leftWidth, setLeftWidth] = useState(53); // Initial width of the left section (percentage)
  const [isDragging, setIsDragging] = useState(false); // State to track dragging

  const MAX_LEFT_WIDTH = 80; // Maximum width for the left section (percentage)
  const MIN_LEFT_WIDTH = 53; // Minimum width for the left section (percentage)

  // Handle mouse down on the resizer
  const handleMouseDown = () => {
    setIsDragging(true);
  };

  

  // Handle mouse move to resize sections
  const handleMouseMove = (e: any) => {
    if (!isDragging) {
      return; // If not dragging, do nothing
    }

    // Calculate the new width of the left section
    const newLeftWidth = (e.clientX / window.innerWidth) * 100;

    // Restrict the width between MIN_LEFT_WIDTH and MAX_LEFT_WIDTH
    if (newLeftWidth >= MIN_LEFT_WIDTH && newLeftWidth <= MAX_LEFT_WIDTH) {
      setLeftWidth(newLeftWidth); // Update the width
    }
  };

  // Handle mouse up to stop dragging
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Add event listeners for mouse move and mouse up
  React.useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }
    // remove the page scrollbar
    // document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

   
  const originalFilePath = findElementByPrompt(assetDetails, 'Original File Path'); // Replace with your logic to determine visibility
  console.log(originalFilePath, 'originalFilePath');
  return (
    <div className="split-screen">
      {/* Left Section */}
      {originalFilePath?.value?.id &&
        <>
          <div className="left-section" style={{ width: `${leftWidth}%` }}>
            <PdfPreview path={originalFilePath?.value?.id} />
          </div>
          {/* Resizer */}
          <div className="resizer" onMouseDown={handleMouseDown}></div>
        </>
      }



      {/* Right Section */}
      <div className="right-section" style={{ width: !originalFilePath?.value?.id ? '100%' : `${100 - leftWidth}%` }}>
        <RightSection assetDetails={assetDetails}/>
      </div>
    </div>
  );
};

export default AssetDetailContent;
